import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-previdenziale-view',
  templateUrl: './form-previdenziale-view.component.html',
  styleUrls: [],
})
export class FormPrevidenzialeViewComponent {
  @Input() ctxBodyFascicolo;
  constructor() {}
}
